/**
 * Created by jiachenpan on 16/11/18.
 */

export function isvalidUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

// 是否是代投
export function isProxy() {
  return location.href.indexOf('fuguifanrongwl.com') > -1
}

/* 合法uri*/
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母*/
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/*
 * 是否为整数
 * 2019.2.25 修改自李贤波
 * 修改原因：当传入数值转化为二进制后位数超过32位，此时使用 | 运算符时将报错
 */
export function validateInteger(num) {
  // 2019.2.25移除
  // return (num | 0) == num;
  // 2019.2.25新增
  if (typeof num === 'number') {
    return num % 1 === 0;
  } else if (typeof num === 'string') {
    return num.indexOf('.') < 0 && num % 1 === 0;
  } else {
    return false;
  }
}

/**
 * 校验是浮点数字（不含负数）可用性
 * @param value: 必选，被校验的值 (.11 这样的数字在校验时会自动转为0.11)
 * @param length: 可选，浮点位数，默认 2
 * */
export function validateFloat(value, length = 2) {
    return new RegExp(`^\\d+(?:\\.\\d{1,${length}})?$`).test(value)
}

/**
 * 校验是否为一个Object对象
 * @param target: 需要校验的目标
 * @param isEmpty: Boolean 是否允许为空对象
 * */
export function isObject(target, isEmpty) {
    // if (typeof target !== 'object') return false;
    if (Object.prototype.toString.call(target) !== '[object Object]') return false;
    if (!isEmpty) return true;
    for (let key in target) {
        if (target.hasOwnProperty(key)) return true;
    }
    return false;
}

export function isNumber(target) {
    if (typeof target === 'number') {
        return target === 0 || !!target;
    } else {
        return /^-?(\d+\.)?\d+$/.test(target);
    }
}

export function isUndefined(value) {
    return typeof value === 'undefined'
}

export function isString(value) {
    return typeof value === 'string';
}

// 默认的文件校验规则
const defaultFileRules = {
    size: 500, // 500KB
    accept: /[./](gif|jpe?g|png)$/i, // 图片格式
    hasRatio: false // 是否需要校验高宽比例
};

/**
 * 根据条件校验本地图片信息，返回Promise的处理结果
 * @param file: 通过el-upload选择的单个文件对象
 * @param _rules: 文件的校验规则
 *        _rules: { accept, size, minWidth, maxWidth, minHeight, maxHeight, noRatio, 'tips' }
 * */
export function validateLocalImg(file, _rules) {
    const rules = Object.assign({}, defaultFileRules, _rules);
    return new Promise((resolve, reject) => {
        // console.log('validateLocalImg:', rules, file);
        const raw = file.raw;
        if (
            (!!raw.type.trim() && !rules.accept.test(raw.type)) ||
            !rules.accept.test(raw.name)
        ) {
            return reject(`图片格式不正确!`, 'type');
        }

        // 校验文件大小，单位KB
        const sizeExceeded = file.size / 1024 > rules.size;
        if (sizeExceeded) {
            return reject(`图片大小不能超过${rules.size}KB!`, 'size')
        }

        // 校验图片的尺寸
        const image = new Image();
        image.onload = () => {
            const {width, height} = image;
            const measure = {width, height};

            if (!validateImgMeasure(measure, rules)) {
                // 提示建议的比例和范围
                const info = rules.ratio && rules.range ? `，建议${rules.ratio}，${rules.range}` : '';
                reject(rules.tips || `图片尺寸不正确${info}!`, 'measure');
            } else {
                resolve({
                    name: file.name,
                    measure,
                    // src: URL.createObjectURL(file.raw),
                    src: file.url,
                    uid: file.uid,
                    status: 'loading' // ready
                });
            }
        };
        image.onerror = () => {
            reject('图片读取失败');
        };
        image.src = file.url;
    })
}

// 校验图片长宽比例与尺寸
export function validateImgMeasure({width, height}, rules = {}) {
    // 长 scaleLength=width, 宽 scaleWidth=height
    const ruleRatio = rules.hasRatio ? (rules.ratio || rules.scaleLength / rules.scaleWidth) : 0;
    const imgRatio = rules.hasRatio ? width / height : 0;
    const squareSize = rules.squareSize;
    if (squareSize) {
        // 正方形尺寸
        rules = Object.assign({}, rules, {
            minWidth: squareSize,
            maxWidth: squareSize,
            minHeight: squareSize,
            maxHeight: squareSize,
        })
    }
    return !(
        // `hasRatio` 需要校验比例
        (rules.hasRatio && (ruleRatio !== imgRatio || Math.abs(ruleRatio - imgRatio) > 0.001)) ||
        width < rules.minWidth || height < rules.minHeight ||
        width > rules.maxWidth || height > rules.maxHeight
    )
}

// 校验本地文件的格式与大小
export function validateLocalFile(file, _rules) {
    const rules = Object.assign({}, defaultFileRules, _rules);
    return new Promise((resolve, reject) => {
        const raw = file.raw;
        if (
            (!!raw.type.trim() && !rules.accept.test(raw.type)) // || !rules.accept.test(raw.name)
        ) {
            return reject(`文件格式不正确!`, 'type');
        }

        // 校验文件大小，单位KB
        const sizeExceeded = file.size / 1024 > rules.size;
        if (sizeExceeded) {
            return reject(`您上传的文件大小不能超过${rules.size}KB!`, 'size');
        }

        resolve({
            name: file.name,
            src: file.url,
            uid: file.uid,
            status: 'loading' // ready
        })
    })
}

/**
 * 获取视频信息，返回Promise的处理结果
 * @param {string} url: 必填，视频文件URL
 * @param [options] 可选项，可额外返回某一帧的图片(imgBase64)及文件(imgFile:Blob)
 * @param {boolean} [options.needFile] 是否获取图片文件
 * @param {number} [options.currentTime] 指定帧(默认0.02)
 * @param {number} [options.quality] 图片质量(默认1.0)
 * @param {number} [options.fileSize] 文件大小(字节)，用于计算码率
 * @return Promise {width, height, duration, kbps?, type, imgBase64?, imgFile?}
 */
export async function getVideoInfo(url, options) {
    return new Promise((resolve, reject) => {
        if (!url) {
            reject('缺少文件URL');
            return
        }
        const video = window.document.createElement('video');
        const ops = isObject(options) ? options : {};
        // video.volume = 0;
        video.muted = true; // 静音
        video.crossOrigin = 'anonymous'; // 跨域

        // 监听已加载第一帧
        // 更多事件 durationchange canplay canplaythrough
        // https://developer.mozilla.org/zh-CN/docs/Web/HTML/Element/video#事件
        video.addEventListener('loadeddata', function (e) {
            // 获取帧数可参考以下资料
            // https://developer.mozilla.org/zh-CN/docs/Web/API/HTMLVideoElement
            // https://github.com/mdn/sprints/issues/2250
            // 总时长，单位为秒（小数部分将被四舍五入）
            const duration =  Math.round(this.duration || 0);
            const res = {
                width: this.videoWidth,
                height: this.videoHeight,
                duration,
            };
            if (options) {
                if (ops.fileSize) {
                    // 视频文件的码率的算法：码率(Kbps，Kb每秒)=文件大小(KB) * 8(B=Byte字节，1KB=8Kb) / 时间(秒)
                    // 注意：此处未区分音频与视频，因此计算会有误差。
                    res.kbps = (ops.fileSize / 1024 * 8 / duration || 0).toFixed(0);
                }
                // 注意：部分浏览器中，可能需要等待一定时间才能将视频内容渲染至 Canvas
                setTimeout(() => {
                    Object.assign(res, captureImage(this, ops));
                    resolve(res)
                    video.remove();
                }, 10);
            } else {
                resolve(res)
                video.remove();
            }
        });

        // 监听错误
        video.addEventListener('error', () => {
            video.remove();
            reject('读取视频信息失败')
        });

        video.src = url;
        if (options) {
            video.currentTime = ops.currentTime || 0.00; // 设定播放位置
        }
        // video.setAttribute('style', `position: fixed;z-index: 99999;left: 10px;top: 10px;background-color: rgba(0,0,0,0.5);`);
        // window.document.querySelector('body').append(video);
    })
}

// 捕捉视频的某帧的数据
function captureImage(videoTarget, {type, name, needFile, quality}) {
    // 创建一个画布
    const canvas = window.document.createElement('canvas');
    // 设置为视频的尺寸
    canvas.width = videoTarget.videoWidth || 100;
    canvas.height = videoTarget.videoHeight || 100;
    canvas.getContext('2d').drawImage(videoTarget, 0, 0, canvas.width, canvas.height);

    const imgType = type || 'image/jpeg';
    // base64模式的图片
    const imgBase64 = canvas.toDataURL(imgType, quality || 1.0);
    // 图片文件数据，可直接上传服务器
    const imgFile = needFile ? dataURItoBlob(imgBase64, name) : null;

    canvas.remove();
    return {
        imgBase64,
        imgFile,
        imgPostfix: imgType.replace(/.*\//, ''), // 图片文件后缀
    }
}

// 将Base64的图片数据转换成Blob
function dataURItoBlob(base64Data = '', filename = '') {
    let byteString;
    let [before = '', content = ''] = base64Data.split(',');
    if (before && content) {
        if (before.indexOf('base64') >= 0) { // base64数据
            // 解码base64字符串
            byteString = atob(content);
        } else { // 其他
            // 解码通过escape转义编码的字符串
            byteString = unescape(content); // 此方法已从 Web 标准中删除
        }
    } else {
        return null;
    }

    // 读取文件的MIME类型
    const mimeString = before.split(':')[1].split(';')[0];
    // 准备`二进制补码8位无符号整数`的数组
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
        // 逐个获取UTF-16编码单元的数字，并添加至数组对应的位置
        ia[i] = byteString.charCodeAt(i);
    }

    // blob的内容由参数数组中给出的值的串联组成
    const blob = new Blob([ia], { type: mimeString });
    blob.name = (filename || String(Date.now())).replace(/\.\w*$/, '.' + mimeString.replace(/.*\//, ''));
    return blob;
}

// 将本地图片文件的内容转为 Base64 字符串
export async function localFileToBase64 (file) {
    return new Promise((resolve, reject) => {
        // 参考 https://developer.mozilla.org/zh-CN/docs/Web/API/FileReader
        const reader = new FileReader();
        // 即将被读取的 Blob 或 File 对象。
        // URL格式的字符串（base64编码）以表示所读取文件的内容
        reader.readAsDataURL(file);
        // 读取操作完成后返回包含 result 的 reader 对象
        reader.onload = function () {
            reader.url = URL.createObjectURL(file);
            resolve(reader)
        }
        reader.onerror = reject
    })
}



// WEBPACK FOOTER //
// ./src/utils/validate.js